import TeamFeed from './TeamFeedContainer';

export default TeamFeed;
